import React, { useState } from 'react';
import styled from 'styled-components';
import { breakpoint, theme } from '../../theme';
import { ChevronDownIcon } from '../../assets';
import { LinkText, UIText } from '../typography';
import { useBreakpointMap } from '../../utils';

export type Link = {
  linkText: string;
  url: string;
};

export type LinkColumn = {
  title: string;
  links: Link[];
};

const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[1].rem};
  display: flex;
  flex-direction: column;
  margin-bottom: ${theme.spacings[2].rem};
`;
const LinkColumnBox = styled.div`
  margin-top: ${theme.spacings[5].rem};
`;

const MobileLinkContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacings[4].rem} 0;
  position: relative;
  cursor: pointer;
`;

const ResponsiveLinkTitle = styled(UIText).attrs({
  size: 'md',
  color: `${theme.colors.primary.white}`,
})`
  font-weight: bold;
`;

const LinkTitle = styled(ResponsiveLinkTitle)`
  && {
    margin-bottom: ${theme.spacings[3].rem};
  }
`;

const FooterLink = styled(LinkText)`
  &&& {
    ${breakpoint('sm')`
      font-size: 12px;
    `}
    color: ${theme.colors.primary.white};
    font-size: 16px;
  }
`;

const StyledChevronDownIcon = styled(ChevronDownIcon)<{ $isExpanded: boolean }>`
  fill: ${theme.colors.primary.white};
  transform: rotate(${({ $isExpanded }) => ($isExpanded ? '180deg' : '0deg')});
  transition: transform 0.3s ease-in-out;
`;

const ResponsiveLinkWrapper = styled.div`
  width: 100%;
  position: relative;
  border-top: 1px solid ${theme.colors.primary.white};
`;
export const FooterLinks: React.FC<LinkColumn> = ({ title, links }) => {
  const [expanded, setExpanded] = useState(false);
  const viewportSize = useBreakpointMap({
    xs: 'Responsive',
    sm: 'tablet',
    md: 'Desktop',
  });
  const isMobile = viewportSize !== 'Desktop';
  const toggleExpand = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  return (
    <>
      {isMobile ? (
        <ResponsiveLinkWrapper>
          <MobileLinkContainer onClick={toggleExpand}>
            <ResponsiveLinkTitle>{title}</ResponsiveLinkTitle>
            <StyledChevronDownIcon $isExpanded={expanded} width={16} />
          </MobileLinkContainer>
          {expanded && (
            <LinkContainer>
              {links.map((link) => (
                <FooterLink key={link.linkText} href={link.url}>
                  {link.linkText}
                </FooterLink>
              ))}
            </LinkContainer>
          )}
        </ResponsiveLinkWrapper>
      ) : (
        <LinkColumnBox>
          <LinkTitle>{title}</LinkTitle>
          <LinkContainer>
            {links.map((link) => (
              <FooterLink key={link.linkText} href={link.url}>
                {link.linkText}
              </FooterLink>
            ))}
          </LinkContainer>
        </LinkColumnBox>
      )}
    </>
  );
};
